import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);
import auth from "./modules/auth";
import {defaultModalSize} from "@/constants/general";
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general.js";


export default new Vuex.Store({
  state: {
    defaultModalSize,
    DEFAULT_MODAL_OPACITY,
    DEFAULT_MODAL_OVERLAY_COLOR,
    navbar_expanded: false,
    isLoading: false,
    showModalVideoLives: false,
    session_expired: false,
    user_desactivated: false,
    isLoadingMessage: 'Aguarde enquanto preparamos o ambiente pra você...',
    selectedYear: 2023,
    currentYear: (new Date()).getFullYear(),
  },
  mutations: {
    SET_IS_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_SESSION_EXPIRED(state, payload = true) {
      state.session_expired = payload;
    },
    SET_SHOW_MODAL_VIDEO_LIVES(state, payload) {
      state.showModalVideoLives = payload;
    },
    SET_USER_DESACTIVATED(state, payload = true) {
      state.user_desactivated = payload;
    },
    SET_YEAR(state, year){
      state.selectedYear = year
    }
  },
  actions: {
    isLoading({commit}, value = true) {
      commit("SET_IS_LOADING", value)
    }
  },
  getters:{

  },
  modules: {
    auth,
  },

});
